import { render } from "./OwnerAccount-AddSMS.vue?vue&type=template&id=44c52332&scoped=true"
import script from "./OwnerAccount-AddSMS.vue?vue&type=script&lang=js"
export * from "./OwnerAccount-AddSMS.vue?vue&type=script&lang=js"

import "./OwnerAccount-AddSMS.vue?vue&type=style&index=0&id=44c52332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c52332"]])

export default __exports__